import { useQuery } from "@tanstack/react-query";
import {
  CheckoutListItem,
  checkoutService,
} from "../../../api/services/checkoutService";

const checkoutKeys = {
  all: ["checkout"] as const,
  lists: () => [...checkoutKeys.all, "lists"] as const,
  list: (dbName: string, ops: string) =>
    [...checkoutKeys.lists(), dbName, ops] as const,
};

export function useCheckoutList(ops: string, dbName: string, enabled: boolean = true) {
  return useQuery({
    queryKey: checkoutKeys.list(dbName, ops),
    queryFn: async (): Promise<CheckoutListItem[]> => {
      const response = await checkoutService.getCheckoutList({ dbName, ops });
      return response.data || [];
    },
    enabled: enabled && !!dbName && !!ops,
    refetchInterval: 20000,
    staleTime: 15000,
    retry: 1,
  });
}
